import PasswordFieldBase from '../base/PasswordField';
import createField from './createField';


const PasswordField = createField(PasswordFieldBase);

export default PasswordField;
